import React, { Component } from "react";
import styled from "styled-components";
import AppHeader from "../../components/header/AppHeader";
import { withRouter } from "react-router-dom";
import * as aaUtil from "../../ath/utils/aaUtils";

import "./FixedLayout.css";

class FixedLayout extends Component {
  componentDidMount() {
    if (window.location.pathname.includes("/hair/")) aaUtil.mountAdobeScript();
  }

  render() {
    let EmptyDiv = styled.div`
      order: 2;
      height: 3.5em;
    `;

    return (
      <div className="intro-fixed">
        <AppHeader
          location={this.props.match.path}
          history={this.props.history}
        />
        {/*(this.props.match.path !== "/onboarding" ||
    this.props.location.pathname === "/hair/onboarding") && <EmptyDiv />*/}
        {this.props.children}
      </div>
    );
  }
}

export default withRouter(FixedLayout);



// WEBPACK FOOTER //
// ./src/views/layout/FixedLayout.js